var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarHearingStreamlineFlex1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05359 8.69693C2.05359 5.02788 5.02794 2.05353 8.69699 2.05353C12.366 2.05353 15.3404 5.02788 15.3404 8.69693C15.3404 10.7771 14.3843 12.634 12.8876 13.8521C12.8933 14.1348 12.8962 14.4329 12.8962 14.7472C12.8962 17.5057 10.66 19.7418 7.90156 19.7418C5.14308 19.7418 2.05359 17.5057 2.05359 14.7472",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3534 8.52241C11.3534 7.05431 10.1633 5.8642 8.69521 5.8642C7.22712 5.8642 6.03699 7.05431 6.03699 8.52241V11.2972C7.1779 11.2972 8.0635 12.2555 8.0635 13.1713V14.3789",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.562 12.1376C22.8923 16.2245 20.6578 20.6161 16.5708 21.9464",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5706 13.3057C18.211 15.2732 17.1353 17.3873 15.1678 18.0277",
    stroke: "black",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarHearingStreamlineFlex1);
export default __webpack_public_path__ + "static/media/Ear-Hearing--Streamline-Flex 1.3ef7517a076413477cb87065de6aa40a.svg";
export { ForwardRef as ReactComponent };